import { FirebaseDataService } from "../../../../services/firebase-data.service";

const firebaseDataService = new FirebaseDataService();

export function fetchGraphUTMCampaign(statsObj, user, graph) {
  return new Promise(async (resolve, reject) => {
    try {
      firebaseDataService.getStats(statsObj, user, graph, "noncadenceUTMchart").subscribe((data) => {
        resolve({ data });
      });
    } catch (error) {
      reject(error);
    }
  });
}